/**
 * Object URL registry.
 *
 * The kiosk runs for hours across hundreds of sessions. Every un-revoked object
 * URL pins its blob in memory, and a few hundred five-second 720p clips will
 * take the WebView down around hour three. So: no bare createObjectURL calls
 * anywhere in the app. Everything goes through here, and session reset revokes
 * the lot.
 */

import { noteEvent } from './diagnostics';

const live = new Set<string>();

export function createObjectUrl(blob: Blob): string {
  const url = URL.createObjectURL(blob);
  live.add(url);
  return url;
}

export function revokeObjectUrl(url: string | null | undefined): void {
  if (!url) return;
  URL.revokeObjectURL(url);
  live.delete(url);
}

/** Called on every session reset. Belt and braces for anything leaked. */
export function revokeAllObjectUrls(): void {
  if (live.size === 0) return;
  noteEvent(`revoking ${live.size} object URL(s)`);
  live.forEach((url) => URL.revokeObjectURL(url));
  live.clear();
}

/** Exposed for the admin view so a leak is visible before it is fatal. */
export function liveObjectUrlCount(): number {
  return live.size;
}
